import { Box, Card, CardContent, IconButton, Typography } from "@mui/material";
import useCourseIdStore from "../../../store/useCourseIdStore";

const RelatedClassCard = ({ img, name }) => {
  const { setCourseId } = useCourseIdStore();
  return (
    <Card
      sx={{
        position: "relative",
        height: "230px",
        backgroundImage: `url(${img})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        borderRadius: "15px",
        overflow: "hidden",
        boxShadow: "none",
      }}
    >
      <CardContent
        sx={{
          position: "absolute",
          bottom: "12px",
          left: "15px",
          right: "15px",
          background: "linear-gradient(90.96deg, rgba(255, 255, 255, 0.5) 1.69%, rgba(255, 255, 255, 0.8) 98.95%)",
          backdropFilter: 'blur(5px)',
          borderRadius: "15px",
          padding: "7px 20px",
          display: "flex",
          paddingBottom: "7px !important",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box>
          <Typography variant="body1">{name}</Typography>
          <Typography variant="h6" color="secondary.main" >From : 1-01-2025   To : 31-01-2025</Typography>
        </Box>
        <IconButton>
          <Typography variant="h5" color={"blue.main"}>View All Details</Typography>
        </IconButton>

      </CardContent>
    </Card>
  );
};

export default RelatedClassCard;

